import './footer.scss';
import state from '../../state';
import FooterList from './FooterList';
function Footer() {
   let date = new Date().getFullYear();
   let FooterItem = state.FooterList.map ((col, idx) =>
   { 
      return ( 
      <div  key={idx} className="col">
         <FooterList  list={col} />
      </div>
      )
   });
   return (
      <footer className="footer">
         <div className="footer__wrapper">
            <div className="footer__row">
               <div className="footer__block-hello">
                  <div className="footer__logo">
                     <a className="footer__logo-link link" target="_blank" rel="noreferrer"  href="https://www.pult.ru/">
                        <img  className="pic" src= "/img/logo_footer.svg" alt= "PULT.RU"></img>
                     </a>
                  </div>
                  <div className="footer__call">
                  <a className="footer__tel link " href="tel:+78122134437"   rel="noreferrer" target="_blank">8&nbsp;(812)&nbsp;213-44-37</a>
                     <div className="call">
                     <p className="footer__call-text">Звонок по России бесплатный</p>
                     </div>
                  </div>
               </div>
               <div className="footer__col">
                  {FooterItem}
               </div>
            </div>
            
            <p className="footer__copyright">
               {date} &copy;/ PULT.RU /Все права защищены.
            </p>
         </div>
      </footer>
   );
}

export default Footer;
